import { BsIcon } from 'src/ui/shared/components/icon/bs-icon.models';

export type ToastTargetType =
    | 'job'
    | 'contact'
    | 'organisation'
    | 'settings'
    | 'individual'
    | 'changeRequest'
    | 'organisationSetting';
export type EntityAction = 'create' | 'update' | 'delete' | 'withdraw' | 'publish';

interface IconTypeMeta {
    icon: BsIcon;
}

export const ICON_TYPE_META: { [key in ToastTargetType]: IconTypeMeta } = {
    job: { icon: 'briefcase' },
    contact: { icon: 'people' },
    organisation: { icon: 'building' },
    individual: { icon: 'person' },
    settings: { icon: 'envelope' },
    changeRequest: { icon: 'briefcase' },
    organisationSetting: { icon: 'envelope' },
};
